import Upscaler from 'upscaler'
import x2 from '@upscalerjs/esrgan-slim/2x'

// Singleton upscaler instance to prevent repeated model downloads
let upscalerInstance = null
let isInitializing = false
let initializationPromise = null

/**
 * Get or create the singleton upscaler instance
 * @returns {Promise<Upscaler>} The upscaler instance
 */
export const getUpscalerInstance = async () => {
    // If instance already exists, return it
    if (upscalerInstance) {
        return upscalerInstance
    }

    // If initialization is in progress, wait for it
    if (isInitializing && initializationPromise) {
        return initializationPromise
    }

    // Start initialization
    isInitializing = true
    initializationPromise = new Promise(async (resolve, reject) => {
        try {
            upscalerInstance = new Upscaler({
                model: x2,
            })

            // Pre-warm the upscaler by calling a method that triggers model loading
            // This ensures the model is downloaded and cached
            await upscalerInstance.getModel()

            isInitializing = false
            resolve(upscalerInstance)
        } catch (error) {
            console.error('Failed to initialize upscaler:', error)
            isInitializing = false
            upscalerInstance = null
            initializationPromise = null
            reject(error)
        }
    })

    return initializationPromise
}

/**
 * Reset the upscaler instance (useful for testing or error recovery)
 */
export const resetUpscalerInstance = () => {
    upscalerInstance = null
    isInitializing = false
    initializationPromise = null
}

